//InStockScreen.js
import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import { API_BASE_URL } from "../Config";
import { Alert, Row, Col, Spinner, Container } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { CartContext } from "../contexts/CartContext";
import { MaintenanceModeContext } from "../contexts/MaintenanceModeContext";
import { SvgErrorAlert } from "../components/Svgs";
import Product from "../components/Product";

import Banner from "../components/Banner"; 

function InStockScreen() {
  const { t } = useTranslation();
  const fetcher = (url) => fetch(url).then((res) => res.json());
  const { data, error } = useSWR(
    `${API_BASE_URL}/api/stock/`,
    fetcher
  );

  const [isLoading, setIsLoading] = useState(false);
  const maintenanceMode = useContext(MaintenanceModeContext);

  const { products, setProducts } = useContext(CartContext);

  useEffect(() => {
    setIsLoading(!error && !data);
    if (data) {
      setProducts(data.products);
    }
  }, [data, setProducts, error]);

  if (maintenanceMode) {
    return <div className="text-center pt-5">{t('website_maintenance')}</div>;
  } else if (isLoading || !products) {
    return (
      <div className="spinning">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <Container className="pb-3">

        <Banner />
        
        <h3 className="pb-md-1">{t('in_stock')}</h3>

        {error && (
          <Alert variant="danger">
            <SvgErrorAlert /> {t('fetch_error')}
          </Alert>
        )}
        {products && (
          <>
            {products && data && data.products && (
              <Row>
                <Col>
                  <div className="text-center pb-3">
                    {data.products.length < 2 ? (
                        t('product_found', { count: data.products.length })
                      ) : (
                        t('products_found', { count: data.products.length })
                      )}
                  </div>
                </Col>
              </Row>
            )}

            <Row>
              {products.map((product) => (
                <Col
                  className="my-2 card-border"
                  sm={6}
                  md={6}
                  lg={4}
                  xl={3}
                  key={product.id}
                >
                  <Product key={product.id} product={product} sourceScreen="InStockScreen" />
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    );
  }
}

export default InStockScreen;
